import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    noAvailableChannels: PropTypes.bool,
};
const defaultProps = {
    noAvailableChannels: false,
};

function HomeNullSelect(props) {
    return (
        <div>
            <div className="channelHeadingFlex--centered">
                <div className="channelHeadingFlex__heading">
                    <h2 className="heading-lg">
                        {(props.noAvailableChannels) ?
                            Strings['en'].dashboard.NO_CHANNELS
                            :
                            Strings['en'].dashboard.SELECT_CHANNEL
                        }
                    </h2>
                </div>
            </div>
        </div>
    );
}

HomeNullSelect.propTypes = propTypes;
HomeNullSelect.defaultProps = defaultProps;

export default HomeNullSelect;